import React from 'react';
import { Modal } from '@components/molecules/Modal';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Input } from '@components/atoms/Input';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (values: { name: string }) => void;
  initialName?: string;
  isSubmitting?: boolean;
};

const validationSchema = Yup.object().shape({
  name: Yup.string().trim().min(2, 'Too short').required('Required'),
});

export const CreateEditCrewModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onSubmit,
  initialName,
  isSubmitting,
}) => {
  const formik = useFormik<{ name: string }>({
    initialValues: { name: initialName || '' },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => onSubmit(values),
  });

  const hasError = Boolean(formik.touched.name && formik.errors.name);

  return (
    <Modal
      title={initialName ? 'Edit Crew' : 'Create Crew'}
      isOpen={isOpen}
      onClose={onClose}
      isLoading={isSubmitting}
      confirmText={initialName ? 'Save' : 'Create'}
      handleConfirm={formik.submitForm}
      disableConfirm={!formik.isValid || !formik.dirty || isSubmitting}
      size="small">
      <div className="flex flex-col gap-3">
        <label className="text-sm font-medium">Crew name</label>
        <Input
          name="name"
          placeholder="Enter crew name"
          value={formik.values.name}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={hasError}
        />
        {hasError && (
          <span className="text-xs text-red-600">{formik.errors.name}</span>
        )}
      </div>
    </Modal>
  );
};
